import React from 'react';
import pure from 'recompose/pure';


let HeartBeat = props =>
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 557.5" dangerouslySetInnerHTML={{__html: '<path d="M470 0c-75.824 0-124.494 52.515-150 99.811C294.494 52.514 245.824 0 170 0 73.796 0 0 78.058 0 181.585c0 27.013 5.409 51.951 15.368 75.915H158.41l32.318-64.636c6.372-12.708 27.172-12.708 33.544 0L282.5 309.32l20.727-41.455c6.373-12.707 27.173-12.707 33.546 0L357.5 309.32l58.228-116.455c6.372-12.707 27.172-12.707 33.545 0L481.59 257.5h143.043C634.59 233.536 640 208.598 640 181.585 640 78.057 566.204 0 470 0"/><path d="M453.228 284.636L432.5 243.181l-58.228 116.455A18.757 18.757 0 0 1 357.5 370a18.757 18.757 0 0 1-16.773-10.364L320 318.181l-20.728 41.455c-6.372 12.708-27.172 12.708-33.545 0L207.5 243.181l-20.727 41.455A18.757 18.757 0 0 1 170 295H35.046c38.592 60.718 108.093 118.391 195.03 191.766 24.408 20.599 50.373 42.518 77.636 66.156A18.725 18.725 0 0 0 320 557.5c4.376 0 8.752-1.52 12.286-4.578 27.265-23.638 53.229-45.556 77.636-66.156C496.86 413.391 566.36 355.717 604.951 295H470a18.757 18.757 0 0 1-16.773-10.364"/>'}}/>

HeartBeat = pure(HeartBeat);

export default HeartBeat;



// WEBPACK FOOTER //
// ./images/SVG/HeartBeat.jsx